import { useState } from 'react';
import { Table, Button } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import MyLogins from '../components/MyLogins';
import PageHeader from '../components/PageHeader';
import BindLinkButton from '../components/BindLinkButton';
import InviteUserDrawer from '../components/InviteUserDrawer';
import { useIsMobile } from '../hooks/useIsMobile';
import { ROLES } from './users/users.constants';
import { useUserMutations } from './users/useUserMutations';
import { UserEmail, ProviderTags, RoleSelect } from './users/UserFields';
import UserCardList from './users/UserCardList';

export default function UsersPage() {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  const users = useQuery({ queryKey: ['users-manage'], queryFn: api.usersManage });
  const { changeRole, changeEmail } = useUserMutations();

  const columns = [
    { title: '使用者', dataIndex: 'displayName' },
    {
      title: 'Email',
      dataIndex: 'email',
      render: (e: string | null, r: { id: string }) => <UserEmail email={e} onChange={(v) => changeEmail(r.id, v)} />,
    },
    {
      title: '登入方式',
      dataIndex: 'providers',
      render: (p: string | null) => <ProviderTags providers={p} />,
    },
    {
      title: '角色',
      dataIndex: 'roles',
      width: 180,
      render: (roles: string | null, r: { id: string }) => (
        <RoleSelect roles={roles} width={150} onChange={(roleId) => changeRole(r.id, roleId)} />
      ),
    },
    {
      title: '操作',
      key: 'actions',
      render: (_: unknown, r: { id: string; displayName: string }) => (
        <BindLinkButton userId={r.id} displayName={r.displayName} />
      ),
    },
  ];

  return (
    <div>
      <PageHeader
        title="帳號管理"
        subtitle={users.data ? `共 ${users.data.length} 位使用者` : undefined}
        extra={
          <Button
            type="primary"
            size={isMobile ? 'middle' : 'large'}
            icon={<UserAddOutlined />}
            onClick={() => setOpen(true)}
          >
            邀請使用者
          </Button>
        }
      />

      <MyLogins />

      {isMobile ? (
        <UserCardList
          users={users.data ?? []}
          loading={users.isLoading}
          onRoleChange={changeRole}
          onEmailChange={changeEmail}
        />
      ) : (
        <div className="overflow-hidden rounded-xl border border-black/[0.06] bg-white shadow-sm">
          <Table rowKey="id" loading={users.isLoading} dataSource={users.data ?? []} columns={columns} />
        </div>
      )}

      <InviteUserDrawer open={open} roles={ROLES} onClose={() => setOpen(false)} />
    </div>
  );
}
